/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/CroppingTextLocalization.yaml
/**
Configuration of all the strings for the standalone cropping screen.
*/
export class CroppingTextLocalization {
    /** @param source {@displayType `DeepPartial<CroppingTextLocalization>`} */
    constructor(source = {}) {
        /**
          The cropping progress overlay title.
          
          Default is "Please wait..."
          */
        this.cameraProgressOverlayTitle = 'Please wait...';
        /**
          The 'cancel' button title, located in the top bar of the cropping screen.
          
          Default is "Cancel"
          */
        this.croppingTopBarCancelButtonTitle = 'Cancel';
        /**
          The 'confirm' button title, located in the top bar of the cropping screen.
          
          Default is "Done"
          */
        this.croppingTopBarConfirmButtonTitle = 'Done';
        /**
          The 'detect document' button title, located in the bottom bar of the cropping screen.
          
          Default is "Detect"
          */
        this.croppingDetectButtonTitle = 'Detect';
        /**
          The 'rotate page' button title, located in the bottom bar of the cropping screen.
          
          Default is "Rotate"
          */
        this.croppingRotateButtonTitle = 'Rotate';
        /**
          The 'reset detection' button title, located in the bottom bar of the cropping screen.
          
          Default is "Reset"
          */
        this.croppingResetButtonTitle = 'Reset';
        /**
          The cropping screen title, located in the top bar.
          
          Default is "Crop"
          */
        this.croppingScreenTitle = 'Crop';
        /**
          The accessibility hint for the 'confirm' button, located in the top bar of the cropping screen.
          
          Default is "Tap to apply changes"
          */
        this.accessibilityDescriptionCroppingTopBarConfirmButton = 'Tap to apply changes';
        /**
          The accessibility hint for the 'cancel' button, located in the top bar of the cropping screen.
          
          Default is "Tap to close screen without applying changes"
          */
        this.accessibilityDescriptionCroppingTopBarCancelButton = 'Tap to close screen without applying changes';
        /**
          The accessibility hint for the 'detect document' button, located in the bottom bar of the cropping screen.
          
          Default is "Tap to detect document on the image"
          */
        this.accessibilityDescriptionCroppingDetectButton = 'Tap to detect document on the image';
        /**
          The accessibility hint for the 'rotate page' button, located in the bottom bar of the cropping screen.
          
          Default is "Tap to rotate document"
          */
        this.accessibilityDescriptionCroppingRotateButton = 'Tap to rotate document';
        /**
          The accessibility hint for the 'reset detection' button, located in the bottom bar of the cropping screen.
          
          Default is "Tap to reset document contour to whole image"
          */
        this.accessibilityDescriptionCroppingResetButton = 'Tap to reset document contour to whole image';
        if (source.cameraProgressOverlayTitle !== undefined) {
            this.cameraProgressOverlayTitle = source.cameraProgressOverlayTitle;
        }
        if (source.croppingTopBarCancelButtonTitle !== undefined) {
            this.croppingTopBarCancelButtonTitle = source.croppingTopBarCancelButtonTitle;
        }
        if (source.croppingTopBarConfirmButtonTitle !== undefined) {
            this.croppingTopBarConfirmButtonTitle = source.croppingTopBarConfirmButtonTitle;
        }
        if (source.croppingDetectButtonTitle !== undefined) {
            this.croppingDetectButtonTitle = source.croppingDetectButtonTitle;
        }
        if (source.croppingRotateButtonTitle !== undefined) {
            this.croppingRotateButtonTitle = source.croppingRotateButtonTitle;
        }
        if (source.croppingResetButtonTitle !== undefined) {
            this.croppingResetButtonTitle = source.croppingResetButtonTitle;
        }
        if (source.croppingScreenTitle !== undefined) {
            this.croppingScreenTitle = source.croppingScreenTitle;
        }
        if (source.accessibilityDescriptionCroppingTopBarConfirmButton !== undefined) {
            this.accessibilityDescriptionCroppingTopBarConfirmButton =
                source.accessibilityDescriptionCroppingTopBarConfirmButton;
        }
        if (source.accessibilityDescriptionCroppingTopBarCancelButton !== undefined) {
            this.accessibilityDescriptionCroppingTopBarCancelButton =
                source.accessibilityDescriptionCroppingTopBarCancelButton;
        }
        if (source.accessibilityDescriptionCroppingDetectButton !== undefined) {
            this.accessibilityDescriptionCroppingDetectButton = source.accessibilityDescriptionCroppingDetectButton;
        }
        if (source.accessibilityDescriptionCroppingRotateButton !== undefined) {
            this.accessibilityDescriptionCroppingRotateButton = source.accessibilityDescriptionCroppingRotateButton;
        }
        if (source.accessibilityDescriptionCroppingResetButton !== undefined) {
            this.accessibilityDescriptionCroppingResetButton = source.accessibilityDescriptionCroppingResetButton;
        }
    }
}
//# sourceMappingURL=CroppingTextLocalization.js.map